import { render, staticRenderFns } from "./ActivityDigestCounter.vue?vue&type=template&id=ef3a9b10&scoped=true&lang=html&"
import script from "./ActivityDigestCounter.vue?vue&type=script&lang=js&"
export * from "./ActivityDigestCounter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDigestCounter.vue?vue&type=style&index=0&id=ef3a9b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3a9b10",
  null
  
)

export default component.exports